'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setHttpInterceptors;

var _util = require('./util');

var _getCookie = require('./getCookie');

var _getCookie2 = _interopRequireDefault(_getCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var traceIdKey = 'X-B3-TraceId';
var spanIdKey = 'X-B3-SpanId';
var sampledKey = 'X-B3-Sampled';
var stringToBase64 = window && window.btoa || _util.btoa;

// 过滤敏感key值，避免在sentry日志上被过滤掉，object中的key值会被自动过滤，不再处理
var filterData = function filterData() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filterKey = arguments[1];

  if (typeof json.data === 'string') {
    json.data = json.data.replace(new RegExp(filterKey + '=[^&]+', 'g'), '');
  }
  return json;
};

function setHttpInterceptors(axiosInstance, options) {
  var AuthorizationKey = options.AuthorizationKey,
      tokenKey = options.tokenKey;
  // 设置请求拦截

  axiosInstance.interceptors.request.use(function (config) {
    // 设置默认的headers
    if (options.setHeaderAuth) {
      config.headers[AuthorizationKey] = (0, _getCookie2.default)(tokenKey);
    }

    if (options.enableBase64 && options.needBase64Keys.length) {
      options.needBase64Keys.forEach(function (key) {
        var value = config.headers[key];

        if (value) config.headers[key] = stringToBase64(value);
      });
    }

    if (options.enableTrace) {
      var id = (0, _util.random64Hex)();
      var sampler = +options.traceSampler;

      config.headers[traceIdKey] = id;
      config.headers[spanIdKey] = id;
      if (sampler) config.headers[sampledKey] = sampler;
    }

    // 处理请求数据
    (0, _util.isFn)(options.handleRequestData) && options.handleRequestData(config);

    return config;
  }, function (error) {
    // 处理请求失败
    if ((0, _util.isFn)(options.handleRequestError)) {
      options.handleRequestError(error);
    }

    return Promise.reject(error);
  });

  if (options.useRawData) {
    // 设置响应拦截，原始的不处理
    return axiosInstance.interceptors.response.use(function (response) {
      // 处理响应数据
      options.handleResponseData && options.handleResponseData(response);

      return response;
    }, function (err) {
      // 处理响应失败
      (0, _util.isFn)(options.handleResponseError) && options.handleResponseError(err);

      return Promise.reject(err);
    });
  }

  var errorCodeOkValues = [].concat(options.errorCodeOkValue);
  // 设置响应拦截
  axiosInstance.interceptors.response.use(function (_ref) {
    var config = _ref.config,
        status = _ref.status,
        data = _ref.data;

    var apiInfo = (0, _util.only)(config, 'data headers method url');

    // 处理响应数据
    if ((0, _util.isFn)(options.handleResponseData)) {
      if (options.userDefinedResponse) {
        // 允许用户自定义返回处理结果
        return options.handleResponseData(data, apiInfo);
      }
      options.handleResponseData(data, apiInfo);
    }

    if (status >= 200 && status < 300) {
      if (options.ignoreErrorCode) {
        return data;
      }

      if (errorCodeOkValues.indexOf(data[options.errorCodeKey]) > -1) {
        return data;
      }
    }

    // 处理响应数据非正常的情况
    (0, _util.isFn)(options.handleResponseError) && options.handleResponseError(data, filterData(apiInfo, options.filterKey));

    return Promise.reject(data);
  }, function (err) {
    var config = err.config,
        response = err.response;

    if (!config || !response) {
      // 处理响应失败
      (0, _util.isFn)(options.handleResponseError) && options.handleResponseError(err);

      return Promise.reject(err);
    }

    var apiInfo = (0, _util.only)(response.config, 'data headers method url');

    // 处理响应失败
    (0, _util.isFn)(options.handleResponseError) && options.handleResponseError(response.data, filterData(apiInfo, options.filterKey));

    return Promise.reject(response.data);
  });
}